import { render, staticRenderFns } from "./PricingMethod.vue?vue&type=template&id=36dfbf38"
import script from "./PricingMethod.vue?vue&type=script&lang=js"
export * from "./PricingMethod.vue?vue&type=script&lang=js"
import style0 from "./PricingMethod.vue?vue&type=style&index=0&id=36dfbf38&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports